export default __webpack_public_path__ + "static/media/b7.cc16dbaf.png";